/**
 * Created by akirilyuk on 9/13/16.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/extendedList/caseCommentItemView.tmpl"),
        CommentModel = require("connection-models/ticketTab/CommentModel"),
        CaseCommentItemView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        CaseCommentItemView = Marionette.ItemView.extend({
            template: template,
            className: 'case-comment-item-view',
            model: CommentModel,
            ui:{
                commentMessage: ".comment-message"
            },

            setOdd:function(){
                this.ui.commentMessage.addClass("odd");
            }
        });
    });
    return CaseCommentItemView;
});
